export const MOBILE_QUERY = "(max-width: 767.98px)";

const DEFAULTS = { lanes: "all", blocks: "show", schedules: "show", scheduled: "all", empty: "show" };

export const ALL_FACILITIES = "all";

export const DEFAULT_THRESHOLD = "50";

export const DEFAULT_SCOPE = "group";

export function stateParams({ date, view, tab, facility, threshold, scope, lanes, blocks, schedules, scheduled, empty, hiddenServices, categories, hiddenStatuses }) {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (view) params.set("view", view);
  if (tab && tab !== "calendar") params.set("tab", tab);
  if (facility && facility !== ALL_FACILITIES) params.set("facility", facility);
  if (threshold && String(threshold) !== DEFAULT_THRESHOLD) params.set("threshold", String(threshold));
  if (tab === "fill_rate" && scope) params.set("scope", scope);
  const filters = { lanes, blocks, schedules, scheduled, empty };
  Object.keys(DEFAULTS).forEach((name) => {
    const value = filters[name];
    if (value && value !== DEFAULTS[name]) params.set(name, value);
  });
  (hiddenServices || []).forEach((service) => params.append("hidden_services[]", service));
  (categories || []).forEach((category) => params.append("categories[]", category));
  (hiddenStatuses || []).forEach((status) => params.append("hidden_statuses[]", status));
  return params;
}

export function fetchParams(state, { mobile, limits }) {
  const params = stateParams(state);
  if (!params.has("facility")) params.set("facility", ALL_FACILITIES);
  if (mobile) params.set("layout", "mobile");
  Object.entries(limits || {}).forEach(([kind, limit]) => {
    if (limit) params.set(`${kind}_limit`, String(limit));
  });
  return params;
}

export function facilityChange(current, picked, limits) {
  if (picked === null || picked === undefined || picked === current) return { facility: current, limits };
  return { facility: picked, limits: {} };
}

export function resetDetail() {
  return { ...DEFAULTS, facility: ALL_FACILITIES, hiddenServices: [], categories: [], hiddenStatuses: [], reset: true };
}

export function applyFilter(state, limits, detail) {
  const { reset, facility, ...filters } = detail;
  const change = facilityChange(state.facility, facility, limits);
  return { state: { ...state, ...filters, facility: change.facility }, limits: reset ? {} : change.limits };
}

function filterFlags({ lanes, hiddenServices, blocks, schedules, scheduled, empty, facility, categories, hiddenStatuses }) {
  return [
    !!lanes && lanes !== "all",
    (hiddenServices || []).length > 0,
    blocks === "hide",
    schedules === "hide",
    scheduled === "only",
    empty === "hide",
    !!facility && facility !== ALL_FACILITIES,
    (categories || []).length > 0,
    (hiddenStatuses || []).length > 0,
  ];
}

export function activeCount(state, customOrder = false) {
  return filterFlags(state).filter(Boolean).length + (customOrder ? 1 : 0);
}

export function resettable(state) {
  return filterFlags(state).some(Boolean);
}
